import { MapboxLayerService } from '@/modules/ta/legacy/widget/services/types/MapboxLayerService';
import { STATE } from '@/modules/ta/legacy/widget/mapbox.constants';
import { MapboxLocationMapper } from '@/modules/ta/legacy/widget/services/types/MapboxAutoZoomService';

export class MapboxStateLayerService extends MapboxLayerService {
  constructor(widget) {
    super(widget, STATE);
  }

  getData(data = []) {
    return data
      .filter((row) => row.geocode1 && this.USCountryFilter(row))
      .map((row) => {
        const stateCode =
          MapboxLocationMapper.normalizeState(row.geocode1?.split('-')[1]?.toUpperCase()) ||
          MapboxLocationMapper.normalizeState(row[this.groupedColumn.field]);
        return {
          name: stateCode,
          value: parseInt(String(row[this.column.field]).replace(/,/g, ''), 10),
        };
      })
      .sort((a, b) => b.value - a.value);
  }
}
